import type { ComponentType } from 'react';
import { WelcomeVariant } from 'config/enums';
import morrisonImage from 'assets/images/morrison-brothers.png';

export type WelcomeVariantConfig = {
  headingKey: string;
  descriptionKey: string;
  image?: ComponentType | string;
};

export const WELCOME_VARIANTS: Record<WelcomeVariant, WelcomeVariantConfig> = {
  [WelcomeVariant.Morrison]: {
    headingKey: 'welcome.heading.morrison',
    descriptionKey: 'welcome.description.morrison',
    image: morrisonImage,
  },
};
